import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { submitContact, apiErr } from "@/lib/api";

const empty = { name: "", phone: "", email: "", message: "" };

export default function ContactForm() {
    const [form, setForm] = useState(empty);
    const [loading, setLoading] = useState(false);
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.phone || !form.email || !form.message) {
            toast.error("Please fill in all fields.");
            return;
        }
        setLoading(true);
        try {
            const res = await submitContact(form);
            toast.success(res.message || "Message sent. We'll be in touch.");
            setForm(empty);
        } catch (err) {
            toast.error(apiErr(err, "Could not send. Please try again."));
        } finally {
            setLoading(false);
        }
    };

    const field = "mt-2 h-12 border-white/10 bg-white/5 text-white placeholder:text-white/30 focus-visible:ring-gold-300/40 focus-visible:border-gold-300/50";

    return (
        <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
            <div className="grid gap-5 sm:grid-cols-2">
                <div>
                    <Label className="text-xs uppercase tracking-[0.2em] text-white/55">
                        Name
                    </Label>
                    <Input
                        data-testid="contact-name"
                        value={form.name}
                        onChange={set("name")}
                        placeholder="Your name"
                        className={field}
                    />
                </div>
                <div>
                    <Label className="text-xs uppercase tracking-[0.2em] text-white/55">
                        Phone Number
                    </Label>
                    <Input
                        data-testid="contact-phone"
                        value={form.phone}
                        onChange={set("phone")}
                        placeholder="+91…"
                        className={field}
                    />
                </div>
            </div>
            <div>
                <Label className="text-xs uppercase tracking-[0.2em] text-white/55">
                    Email ID
                </Label>
                <Input
                    type="email"
                    data-testid="contact-email"
                    value={form.email}
                    onChange={set("email")}
                    placeholder="you@business.com"
                    className={field}
                />
            </div>
            <div>
                <Label className="text-xs uppercase tracking-[0.2em] text-white/55">
                    Message
                </Label>
                <Textarea
                    rows={4}
                    data-testid="contact-message"
                    value={form.message}
                    onChange={set("message")}
                    placeholder="Tell me a little about your business and what you need…"
                    className="mt-2 border-white/10 bg-white/5 text-white placeholder:text-white/30 focus-visible:ring-gold-300/40 focus-visible:border-gold-300/50"
                />
            </div>
            <button
                type="submit"
                data-testid="contact-submit"
                disabled={loading}
                className="gold-button inline-flex items-center justify-center gap-2 disabled:opacity-50"
            >
                {loading ? <Loader2 className="animate-spin" size={14} /> : <Send size={14} />}
                Send Message
            </button>
        </form>
    );
}
